import { render } from "./BaseRank.vue?vue&type=template&id=1fa1ae78"
import script from "./BaseRank.vue?vue&type=script&lang=js"
export * from "./BaseRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__